module.exports = __webpack_public_path__ + "static/media/world.2a9434c2.svg";